import React from 'react'

import { ActivityEndUser } from 'modules/accountActivity/domain'
import { InsightOpportunity } from 'modules/accountActivity/domain'

export enum OpenedSidebar {
  FILTER = 'FILTER',
  DETAILS = 'DETAILS',
  CONTACT = 'CONTACT',
  DEAL = 'DEAL',
  NONE = 'NONE'
}

export enum Card {
  NONE,
  COMPANY_CARD,
  SALESFORCE_CARD,
  EXPLAIN_CARD,
  CONTACT,
  RECENT_ACTIVITY,
  DEAL_DETAILS,
  DEAL_ACTIVITY,
  DEAL_ROOMS,
  DEAL_INSIGHTS
}

export const SidebarOpenContext = React.createContext<{
  openedRightSidebar: OpenedSidebar
  setOpenedRightSidebar: (sidebarType: OpenedSidebar) => void
  expandedCard: Card
  setExpandedCard: (cardType: Card) => void
  setSidebarContact: (contact?: ActivityEndUser) => void
  sidebarContact?: ActivityEndUser
  sidebarDeal?: InsightOpportunity
  setSidebarDeal: (deal: InsightOpportunity) => void
  expandedCards: Card[]
  setExpandedCards: (cards: Card[]) => void
}>({
  openedRightSidebar: OpenedSidebar.NONE,
  setOpenedRightSidebar: () => {},
  expandedCard: Card.EXPLAIN_CARD,
  setExpandedCard: () => {},
  setSidebarContact: () => {},
  sidebarContact: undefined,
  sidebarDeal: undefined,
  setSidebarDeal: () => {},
  expandedCards: [],
  setExpandedCards: () => {}
})
